<app-print-layout
  class="print-area"
  (cancelar)="fechar()"
  [printBodyClass]="'print-a3-landscape'">

  <div class="modal-body matriz-scroll">

    <!-- CONSOLIDADA -->
    <ng-container *ngIf="tipoMatriz === 'consolidada'; else matrizUnica">
      <div *ngFor="let secao of secoes; let first = first"
           [ngClass]="{'matriz-visualizacao': true, 'primeira-secao': first}">

        <div class="matriz-cabecalho">
          <div class="linha-ug text-center">
            <span class="texto fw-bold">{{ secao.unidadeGestoraNome || '-' }}</span>
          </div>
          <div class="linha-titulo text-center">
            MATRIZ DE CONSTATAÇÕES
            <span class="colchetes">DEFINITIVA</span>
            – OSA Nº <span class="texto">{{ secao.numeroOsa }}</span>
          </div>
        </div>

        <table class="table table-bordered table-sm matriz-tabela">
          <thead>
          <tr class="th-grupo">
            <th class="col-num-desc" colspan="2">DESCRIÇÃO DA CONSTATAÇÃO</th>
            <th class="col-sit">SITUAÇÃO ENCONTRADA</th>
            <th class="col-risco">RISCO VINCULADO</th>
            <th class="col-crit">CRITÉRIOS INFRINGIDOS</th>
            <th class="col-ev">EVIDÊNCIAS</th>
            <th class="col-causa">CAUSAS</th>
            <th class="col-efeito">EFEITOS</th>
            <th class="col-rec">RECOMENDAÇÕES</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of secao.itensFinalizados">
            <td class="col-num-desc" colspan="2">
              <div class="d-flex align-items-start">
                <span>{{ item.identificador || '-' }}:</span>
                <span class="descricao-texto">{{ item.descricaoConstatacao || '-' }}</span>
              </div>
            </td>
            <td class="col-sit">
              <ng-container *ngIf="item.situacaoEncontrada; else semSituacao">
                <div *ngFor="let linha of item.situacaoEncontrada.split('\n\n')" class="mb-1">
                  <div *ngFor="let sublinha of linha.split('\n')"
                       [ngClass]="{'fw-bold': sublinha.includes(':') && !sublinha.startsWith('Q.')}">
                    {{ sublinha }}
                  </div>
                </div>
              </ng-container>
              <ng-template #semSituacao><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-risco">
              <ng-container *ngIf="item.riscosVinculados; else semRisco">
                <div *ngFor="let linha of item.riscosVinculados.split('\n')">{{ linha }}</div>
              </ng-container>
              <ng-template #semRisco><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-crit">
              <ng-container *ngIf="item.criteriosInfringidos; else semCriterios">
                <ng-container *ngIf="isArray(item.criteriosInfringidos)">
                  <div *ngFor="let criterio of item.criteriosInfringidos">{{ criterio }}</div>
                </ng-container>
                <ng-container *ngIf="!isArray(item.criteriosInfringidos)">
                  <div *ngFor="let linha of item.criteriosInfringidos.split('\n')">{{ linha }}</div>
                </ng-container>
              </ng-container>
              <ng-template #semCriterios><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-ev col-evidencias">
              <div class="evidencias-box">
                <ng-container *ngIf="item.evidenciasDetalhadas && item.evidenciasDetalhadas.length > 0; else semEvidencias">
                  <div *ngFor="let ev of item.evidenciasDetalhadas" class="evidencia-item">
                      <span class="evidencia-icone">
                        <i class="fas fa-paperclip" *ngIf="ev.tipo === 1"></i>
                        <i class="fas fa-link"      *ngIf="ev.tipo === 2"></i>
                        <i class="fas fa-align-left" *ngIf="ev.tipo === 3"></i>
                      </span>
                    <span *ngIf="ev.tipo === 1" class="d-flex flex-column evidencia-texto">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
                        <span class="text-dark">{{ ev.nomeArquivo || extrairTextoSemPrefixo(ev.texto) || '-' }}</span>
                      </span>
                    <span *ngIf="ev.tipo === 2" class="d-flex flex-column">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
                        <a [href]="formatarUrl(extrairTextoSemPrefixo(ev.texto))"
                           target="_blank" rel="noopener"
                           class="text-primary evidencia-link">
                          {{ extrairTextoSemPrefixo(ev.texto) }}
                        </a>
                      </span>
                    <span *ngIf="ev.tipo === 3" class="text-dark evidencia-texto">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }} - </span>
                      {{ extrairTextoSemPrefixo(ev.texto) || '-' }}
                      </span>
                  </div>
                </ng-container>
                <ng-template #semEvidencias><span class="text-muted">-</span></ng-template>
              </div>
            </td>
            <td class="col-causa">{{ item.causa || '-' }}</td>
            <td class="col-efeito">{{ item.efeito || '-' }}</td>
            <td class="col-rec">
              <div *ngFor="let linha of formatarRecomendacoes(item.recomendacoes).split('\n')">
                {{ linha }}
              </div>
            </td>
          </tr>
          </tbody>
        </table>

      </div>
    </ng-container>

    <!-- PRELIMINAR / DEFINITIVA -->
    <ng-template #matrizUnica>
      <div *ngIf="!loading && matriz" class="matriz-visualizacao primeira-secao">

        <div class="matriz-cabecalho">
          <div class="linha-ug text-center">
            <span class="texto fw-bold">
              {{ unidageGestoraNome ? unidageGestoraNome : (sharedaService.getNomeUG() || '-') }}
            </span>
          </div>
          <div class="linha-titulo text-center">
            MATRIZ DE CONSTATAÇÕES
            <span class="colchetes">{{ tipoMatriz | uppercase }}</span>
            <ng-container *ngIf="tipoMatriz !== 'consolidada'">
              – OSA Nº <span class="texto">{{ sharedaService.getNumeroOsa() || '____' }}</span>
            </ng-container>
            <ng-container *ngIf="tipoMatriz === 'consolidada' && titulo">
              – <span class="texto">{{ titulo }}</span>
            </ng-container>
          </div>
        </div>

        <table class="table table-bordered table-sm matriz-tabela">
          <thead>
          <tr class="th-grupo">
            <th class="col-num-desc" colspan="2">DESCRIÇÃO DA CONSTATAÇÃO</th>
            <th class="col-sit">SITUAÇÃO ENCONTRADA</th>
            <th class="col-risco">RISCO VINCULADO</th>
            <th class="col-crit">CRITÉRIOS INFRINGIDOS</th>
            <th class="col-ev">EVIDÊNCIAS</th>
            <th class="col-causa">CAUSAS</th>
            <th class="col-efeito">EFEITOS</th>
            <th class="col-rec">RECOMENDAÇÕES</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of matriz.itens">
            <td class="col-num-desc" colspan="2">
              <div class="d-flex align-items-start">
                <span>{{ item.identificador || '-' }}:</span>
                <span class="descricao-texto">{{ item.descricaoConstatacao || '-' }}</span>
              </div>
            </td>
            <td class="col-sit">
              <ng-container *ngIf="item.situacaoEncontrada; else semSituacao">
                <div *ngFor="let linha of item.situacaoEncontrada.split('\n\n')" class="mb-1">
                  <div *ngFor="let sublinha of linha.split('\n')"
                       [ngClass]="{'fw-bold': sublinha.includes(':') && !sublinha.startsWith('Q.')}">
                    {{ sublinha }}
                  </div>
                </div>
              </ng-container>
              <ng-template #semSituacao><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-risco">
              <ng-container *ngIf="item.riscosVinculados; else semRisco">
                <div *ngFor="let linha of item.riscosVinculados.split('\n')">{{ linha }}</div>
              </ng-container>
              <ng-template #semRisco><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-crit">
              <ng-container *ngIf="item.criteriosInfringidos; else semCriterios">
                <ng-container *ngIf="isArray(item.criteriosInfringidos)">
                  <div *ngFor="let criterio of item.criteriosInfringidos">{{ criterio }}</div>
                </ng-container>
                <ng-container *ngIf="!isArray(item.criteriosInfringidos)">
                  <div *ngFor="let linha of item.criteriosInfringidos.split('\n')">{{ linha }}</div>
                </ng-container>
              </ng-container>
              <ng-template #semCriterios><span class="text-muted">-</span></ng-template>
            </td>
            <td class="col-ev col-evidencias">
              <div class="evidencias-box">
                <ng-container *ngIf="item.evidenciasDetalhadas && item.evidenciasDetalhadas.length > 0; else semEvidencias">
                  <div *ngFor="let ev of item.evidenciasDetalhadas" class="evidencia-item">
                      <span class="evidencia-icone">
                        <i class="fas fa-paperclip" *ngIf="ev.tipo === 1"></i>
                        <i class="fas fa-link"      *ngIf="ev.tipo === 2"></i>
                        <i class="fas fa-align-left" *ngIf="ev.tipo === 3"></i>
                      </span>
                    <span *ngIf="ev.tipo === 1" class="d-flex flex-column evidencia-texto">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
                        <span class="text-dark">{{ ev.nomeArquivo || extrairTextoSemPrefixo(ev.texto) || '-' }}</span>
                      </span>
                    <span *ngIf="ev.tipo === 2" class="d-flex flex-column">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
                        <a [href]="formatarUrl(extrairTextoSemPrefixo(ev.texto))"
                           target="_blank" rel="noopener"
                           class="text-primary evidencia-link">
                          {{ extrairTextoSemPrefixo(ev.texto) }}
                        </a>
                      </span>
                    <span *ngIf="ev.tipo === 3" class="text-dark evidencia-texto">
                        <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }} - </span>
                      {{ extrairTextoSemPrefixo(ev.texto) || '-' }}
                      </span>
                  </div>
                </ng-container>
                <ng-template #semEvidencias><span class="text-muted">-</span></ng-template>
              </div>
            </td>
            <td class="col-causa">{{ item.causa || '-' }}</td>
            <td class="col-efeito">{{ item.efeito || '-' }}</td>
            <td class="col-rec">{{ formatarRecomendacoes(item.recomendacoes) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="loading" class="text-center py-4">
        <mat-spinner class="mx-auto"></mat-spinner>
        <p class="mt-3">Carregando matriz...</p>
      </div>
    </ng-template>

  </div>
</app-print-layout>
